export default {"src":"/_next/static/media/monday-blues.77031772.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};